<template>
  <div class="content">
    <h1>Privacy Policy</h1>
    <p><strong>Last updated:</strong> 2025-06-11</p>

    <h3>1. Overview</h3>
    <p>This Privacy Policy explains how <strong>Take Away Near Me (TANM)</strong> collects, uses, and protects your information when using our services.</p>

    <h3>2. Data We Collect</h3>
    <ul>
      <li>Name, email, and delivery address</li>
      <li>Order details and preferences</li>
      <li>Payment confirmation (via Stripe, not card numbers)</li>
      <li>IP address and usage data (via GA4 & Microsoft Clarity)</li>
    </ul>

    <h3>3. How We Use Your Data</h3>
    <ul>
      <li>Process and deliver your order</li>
      <li>Provide customer support</li>
      <li>Improve our platform</li>
      <li>Send order updates and essential notifications</li>
    </ul>

    <h3>4. Sharing Your Data</h3>
    <p>We share relevant information with:</p>
    <ul>
      <li>Vendors (for order fulfillment)</li>
      <li>Stripe (for payment processing)</li>
      <li>Service providers (e.g., email and analytics)</li>
    </ul>
    <p>We do not sell your data.</p>

    <h3>5. Cookies</h3>
    <p>We use cookies to enable functionality, analytics, and improve UX. See our <a href="/cookie-policy">Cookie Policy</a> for full details.</p>

    <h3>6. Your Rights</h3>
    <p>You have rights to:</p>
    <ul>
      <li>Access your data</li>
      <li>Correct inaccurate data</li>
      <li>Request deletion (where lawful)</li>
    </ul>
    <p>Email <a href="mailto:privacy@tanm.co.uk">privacy@tanm.co.uk</a> for any requests.</p>

    <h3>7. Data Retention</h3>
    <p>We retain order and account data for tax and operational purposes in line with UK regulations.</p>

    <h3>8. Security</h3>
    <p>We follow industry best practices to secure your information.</p>

    <h3>9. Contact</h3>
    <p>Questions? Email <a href="mailto:privacy@tanm.co.uk">privacy@tanm.co.uk</a>.</p>
  </div>
</template>
